import * as styles from './Button.module.css'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { ComponentProps } from 'react'
import classNames from 'classnames'
import { Link } from 'gatsby'

interface Props<T> extends Omit<ComponentProps<typeof Link<T>>, 'ref'> {
  large?: boolean
  secondary?: boolean
  disabled?: boolean
}

export const ButtonLink = <T,>(props: Props<T>) => {
  const {
    large = false,
    secondary = false,
    disabled = false,
    ...LinkProps
  } = props

  return (
    <Link
      {...LinkProps}
      className={classNames(styles.button, {
        [styles.large]: large,
        [styles.secondary]: secondary,
        [styles.disabled]: disabled,
      })}
    />
  )
}
